import type { FaireThemeEntity } from "../../entity_types/theme";

export const timeless_board_books_storytime: FaireThemeEntity = {
  token: "timeless-board-books-storytime",
  type: "theme",
  name: "Timeless Board Books & Storytime",
  description: "",
  teaser: "",
  detail: "",
  bgColor: "#D6E0F0",
  exactProducts: true,
  retailerToken: "r_eer7xgiweo",
  productTokens: [
    "p_hq9bejqrzp",
    "p_a7jbrhemyc",
    "p_qcckwqm2xn",
    "p_kkfwtxybt6",
    "p_3m2mhqwub9",
    "p_4s7rucz3t3",
    "p_cr98ruj8gv",
    "p_q3d7tea4d7",
    "p_3vmq5mttjc",
    "p_zuc3bab8re",
    "p_ncr9uruq8p",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
